var map = {
	"./decidim/avatar-multiuser.png": 79539,
	"./decidim/brands/facebook.svg": 75899,
	"./decidim/brands/google.svg": 85138,
	"./decidim/brands/twitter-x.svg": 76275,
	"./decidim/cc-badge.png": 62257,
	"./decidim/decidim-logo.svg": 13441,
	"./decidim/default-avatar.svg": 4257,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 46135,
	"./decidim/icons.svg": 19968,
	"./decidim/pattern.png": 37731,
	"./decidim/placeholder-card-g.svg": 3232,
	"./decidim/placeholder-card-l.svg": 16971,
	"./decidim/placeholder.jpg": 90914,
	"./decidim/remixicon.symbol.svg": 7320,
	"./decidim/vendor/social-share-button/douban.svg": 93451,
	"./decidim/vendor/social-share-button/email.svg": 98244,
	"./decidim/vendor/social-share-button/facebook.svg": 35168,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 48596,
	"./decidim/vendor/social-share-button/hacker_news.svg": 48840,
	"./decidim/vendor/social-share-button/linkedin.svg": 80770,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 93515,
	"./decidim/vendor/social-share-button/pinterest.svg": 8546,
	"./decidim/vendor/social-share-button/reddit.svg": 80184,
	"./decidim/vendor/social-share-button/telegram.svg": 60877,
	"./decidim/vendor/social-share-button/tumblr.svg": 1098,
	"./decidim/vendor/social-share-button/twitter.svg": 64801,
	"./decidim/vendor/social-share-button/vkontakte.svg": 83947,
	"./decidim/vendor/social-share-button/wechat.svg": 26198,
	"./decidim/vendor/social-share-button/whatsapp.svg": 18446,
	"./decidim/vendor/social-share-button/x.svg": 44028,
	"./decidim/vendor/social-share-button/xing.svg": 57948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45840;